import React from 'react';
import { Link } from 'react-router-dom';
import StaticPage from './StaticPage';

export default function About() {
  return (
    <StaticPage
      title="About ALFÀ"
      subtitle="Physician-led telehealth care for GLP-1 weight management."
      seoDescription="ALFÀ is a telehealth platform offering physician-led GLP-1 weight loss programs. Cash-pay. No insurance required."
    >
      <h2>Our mission</h2>
      <p>
        ALFÀ provides access to physician-led telehealth care for weight management. Patients
        complete an online intake, and a licensed provider reviews their health information to
        determine whether treatment is medically appropriate.
      </p>

      <h2>What we do</h2>
      <p>
        We offer a <Link className="underline" to="/">weight loss program</Link> built around
        compounded semaglutide and tirzepatide. Each plan begins with an online consultation with a
        licensed provider, who determines whether treatment is medically appropriate and, if
        prescribed, provides titration guidance and ongoing follow-up.
      </p>

      <h2>How we're different</h2>
      <p>
        ALFÀ programs are <strong>physician-led</strong> and <strong>cash-pay</strong>, with
        pricing shown before you submit. Your provider reviews your intake, prescribes only when
        medically appropriate, and remains available for follow-up questions.
      </p>

      <h2>Safety first, always</h2>
      <p>
        Prescriptions are filled by a licensed U.S. pharmacy partner. Compounded medications are
        not FDA-approved, and the FDA does not review compounded medications for safety,
        effectiveness, or quality before they are marketed. We encourage every patient to keep
        their primary care provider informed. If treatment is not medically appropriate, it will
        not be prescribed.
      </p>

      <h2>Get in touch</h2>
      <p>
        Have a question about our program, your plan, or your order? <Link className="underline" to="/contact">Reach out here.</Link>
      </p>
    </StaticPage>
  );
}
